import ActionWithPayload from 'moduleBase/reducers/types/ActionWithPayload';
import { CHAT_MODAL_HIDE, CHAT_MODAL_SHOW } from 'moduleChat/modules/modal/constants';
import { ChatModalShowPayloadType } from 'moduleChat/modules/modal/actions/types/ChatModalShowPayloadType';
import { StateType } from 'moduleChat/modules/modal/types/StateType';

const defaultState = {
  isVisible: false,
};

const reducerChatModal = (
  state: StateType = defaultState,
  action: ActionWithPayload,
): StateType => {
  switch (action.type) {
    case CHAT_MODAL_SHOW: {
      const payload = action.payload as ChatModalShowPayloadType;
      return {
        ...state,
        isVisible: true,
        creUserId: payload.creUserId,
        dealId: payload.dealId,
      };
    }
    case CHAT_MODAL_HIDE: {
      return {
        ...state,
        isVisible: false,
      };
    }
    default:
      return state;
  }
};

export { reducerChatModal };
